import { render } from "./edit_building.vue?vue&type=template&id=85601ce4"
import script from "./edit_building.vue?vue&type=script&lang=js"
export * from "./edit_building.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__